import { ArService } from './../../services/ar.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { StationService } from 'src/app/services/station.service';
import { EmployeeService } from 'src/app/services/employee.service';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReservationService } from 'src/app/services/reservation.service';
import * as moment from 'moment';

@Component({
  selector: 'app-add-agency-service',
  templateUrl: './add-agency-service.component.html',
  styleUrls: ['./add-agency-service.component.scss']
})
export class AddAgencyServiceComponent implements OnInit {

  minDate = new Date();
  today = moment().format('MM/DD/YYYY');
  agencyTypes = ['AMEX', 'Retail'];
  statusTypes = [{
    id: false,
    name: "InActive",
    active: 0
  },
  {
    id: true,
    name: "Active",
    active: 1
  }
  ]

  agencyForm: FormGroup;
  isEditMode = false;
  formTitle = '';
  submitted = false
  agencyData: any;
  selectedStations = [];
  allStations: any;
  selectedAgencyType: any;
  agencyByStationId;
  agencyServicesId;
  isAmountChanged = false;
  agencyId;

  PHONE_REGEXP = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4,5}$/;

  public constructor(
    private notifier: NotifierService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private authService: AuthenticationService,
    private router: Router,
    private reservationService: ReservationService,
    private stationService: StationService,
    private employeeService: EmployeeService,
    private authenticationService: AuthenticationService,
    private arService: ArService) {
  }

  ngOnInit() {
    this.getStations();
   // console.log(this.allStations); 
    if (this.route.snapshot.paramMap.get('agencyId') != null) {
      this.agencyId = this.route.snapshot.paramMap.get('agencyId')
    //  console.log(this.route.snapshot.paramMap.get('agencyId'), 'This is Agency Id from URL')
      this.formTitle = "Update Agency";
      this.isEditMode = true;
      this.getAgencyById(this.route.snapshot.paramMap.get('agencyId'));
    } else {
      this.formTitle = "Add Agency"
    }   
    this.initAddAgencyForm();
  }

  getStations() {
    this.arService.getAllstationsWithCode().subscribe((stationData) => {
          this.allStations = stationData['result']
         // console.log(this.allStations)
         })
  }
  
  getAgencyById(agencyId) {
   // console.log(`getting agencyId ${agencyId}`)
    this.selectedStations = [];
    this.spinner.show();
    this.arService.getAgencyDataById(agencyId).subscribe(aData => {
      this.agencyData = aData['result']
    //  console.log(this.agencyData)
      this.selectedStations.push(this.agencyData[0].STATION);
      this.spinner.hide();
      this.initUpdateAgencyForm();
    });
  }

  onAddAgency(values) {
    this.submitted = true;
    this.validateAgency();
    this.agencyForm.markAllAsTouched();
    if (this.agencyForm.invalid) {
      return;
    }
   
    var data = {
      STATION: values.station,
      COMPANY_NAME: values.company_Name,
      CONTACT_FIRST_NAME: values.contact_First_Name,
      CONTACT_LAST_NAME: values.contact_Last_Name,
      CONTACT_PHONE: values.contact_Phone,
      LCB_ID: this.authService.getCurrentUserId(),
      ACTIVE: true
    }                        

    this.spinner.show()
    this.arService.addAgencyData(data).subscribe(res => {
      //console.log(res)
      if (res['status']) {
        this.spinner.hide()
        this.submitted = false
        this.notifier.notify('success', res['message']);
        this.initAddAgencyForm();
      } else {
        this.submitted = false
        this.spinner.hide()
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
       console.log(err);
    })
    this.router.navigateByUrl("home/agencies");
  }


  initAddAgencyForm() {
    this.agencyForm = new FormGroup({
      station: new FormControl('', Validators.compose([Validators.required])),
      company_Name: new FormControl('', Validators.compose([Validators.required])),
      contact_First_Name: new FormControl('', Validators.compose([Validators.required])),
      contact_Last_Name: new FormControl('', Validators.compose([Validators.required])),
      contact_Phone: new FormControl('', Validators.compose([Validators.required, Validators.pattern('[0-9\-\+]*')])), //  , Validators.minLength(10), Validators.maxLength(20), Validators.pattern(this.PHONE_REGEXP)
      active: new FormControl(1, Validators.compose([Validators.required]))      
    });
  }

  initUpdateAgencyForm() {
    this.agencyForm = this.formBuilder.group({
      station: new FormControl(this.agencyData[0].STATION, Validators.compose([Validators.required])),
      company_Name: new FormControl(this.agencyData[0].COMPANY_NAME, Validators.compose([Validators.required])),
      contact_First_Name: new FormControl(this.agencyData[0].CONTACT_FIRST_NAME, Validators.compose([Validators.required])),
      contact_Last_Name: new FormControl(this.agencyData[0].CONTACT_LAST_NAME, Validators.compose([Validators.required])),
      contact_Phone: new FormControl(this.agencyData[0].CONTACT_PHONE, Validators.compose([Validators.required, Validators.pattern('[0-9\-\+]*')])), //  Validators.minLength(10), Validators.maxLength(20), Validators.pattern(this.PHONE_REGEXP)
      active: new FormControl(this.agencyData[0].ACTIVE, Validators.compose([Validators.required])) 
    });
  }

  get agencyFormcontrols() { return this.agencyForm.controls; }

  onUpdateAgency(values) {
    //console.log(values);
    this.submitted = true
    this.validateAgency();
    this.agencyForm.markAllAsTouched();
    if (this.agencyForm.invalid) {
      return;
    }

    var data = {
      STATION: values.station,
      COMPANY_NAME: values.company_Name,
      CONTACT_FIRST_NAME: values.contact_First_Name,
      CONTACT_LAST_NAME: values.contact_Last_Name,
      CONTACT_PHONE: values.contact_Phone,
      LCB_ID: this.authService.getCurrentUserId(),
      AGENCY_ID: parseInt(this.agencyId),
      ACTIVE: values.active
    }  
    
    this.spinner.show();
    this.arService.updateAgencyData(data).subscribe(res => {
      this.spinner.hide();
      if (res['status']) {
        this.notifier.notify('success', res['message']);
        setTimeout(() => {
          this.router.navigateByUrl("home/agencies");
        }, 2000);
      } else {
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
      console.log(err);
    })
  }

  onStationChange(event) {
    this.selectedStations = (event)
  }

  validation_messages = {
    'station': [
      { type: 'required', message: 'Station is required.' }
    ],
    'company_Name': [
      { type: 'required', message: 'Agency is required.' }
    ],
    'contact_First_Name': [
      { type: 'required', message: 'Contact First Name is required.' }
    ],
    'contact_Last_Name': [
      { type: 'required', message: 'Contact Last Name is required.' }
    ],
    'contact_Phone': [
      { type: 'required', message: 'Phone No is required.' },
    //  { type: 'minlength', message: 'Phone No must be minimum 10 digits long.' },
    //  { type: 'maxlength', message: 'Phone No must not be more then 20 digits long.' },
      { type: 'pattern', message: 'Phone No must not contain any alphabets or special characters  other than hyphen(-) and plus(+)' },
    ],
    'active': [
      { type: 'required', message: 'Status is required.' }
    ]
     }

  get f(): any {
    return this.agencyForm.controls;
  }

  onBack() {
    // this.location.back();
    this.router.navigateByUrl("home/agencies");
  }

  validateAgency() {
    //console.log("callingg...");
    if (this.agencyFormcontrols.station.errors) {
      this.notifier.notify('warning', 'Please select Station ');
      return false;
    }
    if (this.agencyFormcontrols.company_Name.errors) {
      this.notifier.notify('warning', 'Please enter Agency ');
      return false;
    }
    if (this.agencyFormcontrols.contact_First_Name.errors) {
      this.notifier.notify('warning', 'Please enter Contact First Name');
      return false;
    }
    if (this.agencyFormcontrols.contact_Last_Name.errors) {
      this.notifier.notify('warning', 'Please enter Contact Last Name');
      return false;
    }
    if (this.agencyFormcontrols.contact_Phone.errors) {
      this.notifier.notify('warning', 'Please enter Phone No');
      return false;
    }
    if (this.agencyFormcontrols.active.errors) {
      this.notifier.notify('warning', 'Please select Status');
      return false;
    }
  }

}
